import {createSelector} from '@ngrx/store';
import {AppState} from '../app-state';

export const selectChallengeBuilderState = (state: AppState) => state.challengeBuilder;

export const selectChallengeBuilderProject = createSelector(selectChallengeBuilderState, state => state.cbProject);

export const selectChallengeBuilderLoading = createSelector(selectChallengeBuilderState, state => state.loading);

export const selectChallengeBuilderNextLoading = createSelector(
  selectChallengeBuilderState,
  state => state.nextLoading
);

export const selectChallengeBuilderBackLoading = createSelector(
  selectChallengeBuilderState,
  state => state.backLoading
);

export const selectChallengeNextValid = createSelector(selectChallengeBuilderState, state => state.challengeNextValid);

export const selectChallengeBuilderPrompts = createSelector(selectChallengeBuilderState, state => state.prompts);
